module.exports = __webpack_public_path__ + "img/classify_img1.76d2e876.png";